var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dissable",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .disabled-color{fill:#ED1E5C;}\n    .disabled-st1{fill:#FFFFFF;}\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "crossedline",
    className: "disabled-color",
    d: "M158.7,382.2c-2.8,0-5.5-1-7.7-3.1c-4.3-4.2-4.4-11.2-0.2-15.5l209.7-215.4   c4.2-4.3,11.2-4.4,15.5-0.2c4.3,4.2,4.4,11.2,0.2,15.5L166.6,378.9C164.4,381.1,161.6,382.2,158.7,382.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "solidline",
    className: "disabled-st1",
    d: "M143.6,367.1c-2.8,0-5.5-1-7.7-3.1c-4.3-4.2-4.4-11.2-0.2-15.5l209.7-215.4   c4.2-4.3,11.2-4.4,15.5-0.2c4.3,4.2,4.4,11.2,0.2,15.5L151.5,363.8C149.3,366,146.5,367.1,143.6,367.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabled);
export default __webpack_public_path__ + "static/media/disabled.8a3404575f5465638673ff72c88bc11f.svg";
export { ForwardRef as ReactComponent };